import React from 'react';
import { useMenuItemDragAndDrop } from '@atlaskit/navigation-system/side-nav-items/drag-and-drop/use-menu-item-drag-and-drop';
import { ContainerAvatar as Avatar } from '@atlaskit/navigation-system';

type UseProjectMenuItemDragAndDropArgs = {
	projectId: string;
	projectKey: string;
	isFavourite: boolean | null | undefined;
	name: string;
	avatar: {
		large?: string;
	};
};

export const NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP = 'nav4-sidebar-project-menu-item-drag-and-drop';

export const useProjectMenuItemDragAndDrop = (props: UseProjectMenuItemDragAndDropArgs) => {
	const { projectId, projectKey, isFavourite, name, avatar } = props;
	return useMenuItemDragAndDrop({
		draggable: {
			getInitialData: () => ({
				id: projectId,
				key: projectKey,
				isFavourite,
				name,
				avatar: avatar.large || '',
				type: NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP,
			}),
			getDragPreviewPieces: () => ({
				elemBefore: <Avatar src={avatar.large || ''} />,
				content: name,
			}),
		},
		dropTarget: {
			getData: () => ({
				id: projectId,
				key: projectKey,
				isFavourite,
				name,
				avatar: avatar.large || '',
				type: NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP,
			}),
			getOperations: () => ({
				'reorder-after': 'available',
				'reorder-before': 'available',
			}),
			canDrop: ({ source }) => source.data.type === NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP,
		},
	});
};
